'use client'
import React, { useEffect, useState } from "react";
import { AppShell } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import NavbarDesktop from "@components/EthinosNavbar/NavbarDesktop";
import NavbarMobile from "@components/EthinosNavbar/NavbarMobile";
import FooterV1 from "@components/FooterV1/FooterV1";
import GSTStripCommon from "@components/molecules/EthinosHomePage/GSTStripCommon";

interface AppshellWrapperProps {
  homePageData: any;
  children: any;
  popularSearches?: boolean;
  PhoneJsx?: React.ReactNode;
  dynamicFooterData?: string;
  pageType?:string
}

export default function AppshellWrapper({
  homePageData,
  children,
  popularSearches = true,
  PhoneJsx,
  dynamicFooterData,
  pageType
}: AppshellWrapperProps) {
  const [opened, { toggle }] = useDisclosure();
   const [showInfoStrip,setShowInfoStrip] = useState(false)
  const [infoStrip,setInfoStrip] = useState({})

  const fetchInfoStripEnabledPages = async()=>{
    let data:any = await fetch("/api/strapi/pagesWithInfoStripHeader",{method:"POST"})
    data = await data.json()
    setInfoStrip(data.data)
    setShowInfoStrip(data?.data?.enabledOnPages?.includes(pageType)?true:false)
  }

  useEffect(()=>{
    fetchInfoStripEnabledPages()
  },[])

  return (
    <>
    <AppShell
      layout="alt"
      header={{ height: 60 }}
      navbar={{
        width: 300,
        breakpoint: "sm",
        collapsed: { desktop: true, mobile: !opened },
      }}
      padding={"0"}
    >
      {
        showInfoStrip &&
        <GSTStripCommon infoStrip={infoStrip} />
      }
      <AppShell.Header
        style={{
          backgroundColor: opened ? "rgb(0,41,57)" : undefined,
        }}
      >
        <NavbarDesktop
          opened={opened}
          toggle={toggle}
          headerList={homePageData?.headerList}
          headerPopover={homePageData?.headerPopover}
          PhoneJsx={PhoneJsx}
        />
      </AppShell.Header>

      <AppShell.Navbar
        py="md"
        px={4}
        style={{ backgroundColor: "rgb(0,41,57)" }}
      >
        <NavbarMobile
          opened={opened}
          toggle={toggle}
          headerList={homePageData?.headerList}
          headerPopover={homePageData?.headerPopover}
        />
      </AppShell.Navbar>
      <AppShell.Main className="bg-white">{children}</AppShell.Main>
      <FooterV1
        homePageData={homePageData}
        popularSearches={popularSearches}
        dynamicFooterData={dynamicFooterData}
      />
    </AppShell>
    </>
  );
}
